import { InputProps } from 'antd';
import React, { ComponentType, FC } from 'react';
import styled from 'styled-components';
import { CopyToClipboard } from '../copy-to-clipboard';
import { Input, InputBackgroundColor, InputBorder } from './input';

const Wrapper = styled.div`
  display: flex;
  gap: var(--spacing-01);
  align-items: center;
  background-color: ${InputBackgroundColor};
  > :not(svg) {
    border-bottom: none;
    cursor: inherit;
  }
  ${InputBorder};
  > svg {
    cursor: pointer;
    margin: 0 var(--spacing-05);
    color: var(--blue-60);
  }
`;

const Divider = styled.div`
  border: 1px solid #a8a8a8;
  height: 25px;
`;

interface Props extends InputProps {
  component?: ComponentType;
  enable?: boolean;
}

export const CopyInput: FC<Props> = (props) => {
  const { component: Component = Input, enable, ...rest } = props;
  const { value } = props;

  return (
    <Wrapper>
      <Component {...rest} disabled={!enable} />
      <Divider />
      <CopyToClipboard textToCopy={value as string} />
    </Wrapper>
  );
};
